import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "onboarding-chat" }
const _hoisted_2 = {
  key: 1,
  class: "onboarding-body",
  relative: ""
}
const _hoisted_3 = {
  class: "header",
  relative: ""
}
const _hoisted_4 = { class: "segment-title" }
const _hoisted_5 = { class: "title" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_Logo = _resolveComponent("Logo")
  const _component_Icon = _resolveComponent("Icon")
  const _component_AIChat = _resolveComponent("AIChat")
  const _component_Steps = _resolveComponent("Steps")
  const _component_CloseModal = _resolveComponent("CloseModal")
  const _directive_window_resize = _resolveDirective("window-resize")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$data.chat)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Logo, {
                  size: "3.2rem",
                  type: "big-icon"
                }),
                _createTextVNode(" " + _toDisplayString($options.title), 1 /* TEXT */)
              ]),
              (!$options.steps)
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 0,
                    class: "pointer",
                    icon: "x-close-thin",
                    height: "4.8rem",
                    width: "4.8rem",
                    "stroke-width": "2",
                    onClick: _cache[0] || (_cache[0] = $event => ($options.onClose()))
                  }))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _withDirectives(_createVNode(_component_AIChat, {
            ref: "chat",
            class: "chat-container",
            mode: "onboarding",
            description: "Genrate can make mistakes. Consider checking important information.",
            placeholder: "Enter your response here...",
            "chat-id": $data.chat?.id,
            history: $options.history,
            generating: $options.generating,
            onOnboardingCompleted: $options.onCompleted,
            onRegenerate: $options.onChat,
            onStop: $options.onStop,
            onAskAi: $options.onChat
          }, null, 8 /* PROPS */, ["chat-id", "history", "generating", "onOnboardingCompleted", "onRegenerate", "onStop", "onAskAi"]), [
            [_directive_window_resize, $options.handleResize]
          ])
        ])),
    ($data.chat)
      ? (_openBlock(), _createBlock(_component_Steps, {
          key: 2,
          ref: "steps_ref",
          history: $options.history,
          onClose: _cache[1] || (_cache[1] = $event => ($options.onClose()))
        }, null, 8 /* PROPS */, ["history"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_CloseModal, { ref: "close" }, null, 512 /* NEED_PATCH */)
  ]))
}